import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

import type { ImprensaContato } from './contatos';

const messages = defineMessages({
  titleBlock: { id: 'mpf_imprensa_block', defaultMessage: 'Imprensa' },
  titulo: { id: 'mpf_imprensa_titulo', defaultMessage: 'Título do bloco' },
  tituloHelp: {
    id: 'mpf_imprensa_titulo_help',
    defaultMessage: 'Em branco, usa "Imprensa".',
  },
  variante: { id: 'mpf_imprensa_variante', defaultMessage: 'Variante' },
  varianteHelp: {
    id: 'mpf_imprensa_variante_help',
    defaultMessage:
      'Destaque é o desenho das "Salas de atendimento ao cidadão" da página de Serviços: título menor, com filete sob ele, e filtro por lista de estados no lugar da busca.',
  },
  variantePadrao: {
    id: 'mpf_imprensa_variante_padrao',
    defaultMessage: 'Padrão',
  },
  varianteDestaque: {
    id: 'mpf_imprensa_variante_destaque',
    defaultMessage: 'Destaque',
  },
  rotuloEmBranco: {
    id: 'mpf_imprensa_rotulo_em_branco',
    defaultMessage: 'Em branco, usa "{padrao}".',
  },
  telefoneRotulo: {
    id: 'mpf_imprensa_telefone_rotulo',
    defaultMessage: 'Rótulo do telefone',
  },
  telefoneSecundario: {
    id: 'mpf_imprensa_telefone_secundario',
    defaultMessage: 'Segundo telefone',
  },
  telefoneSecundarioHelp: {
    id: 'mpf_imprensa_telefone_secundario_help',
    defaultMessage:
      'Opcional. Aparece logo abaixo do primeiro, ex.: o telefone da sede.',
  },
  telefoneSecundarioRotulo: {
    id: 'mpf_imprensa_telefone_secundario_rotulo',
    defaultMessage: 'Rótulo do segundo telefone',
  },
  emailRotulo: {
    id: 'mpf_imprensa_email_rotulo',
    defaultMessage: 'Rótulo do e-mail',
  },
  horarioRotulo: {
    id: 'mpf_imprensa_horario_rotulo',
    defaultMessage: 'Rótulo do horário',
  },
  contatosLinkRotulo: {
    id: 'mpf_imprensa_contatos_link_rotulo',
    defaultMessage: 'Rótulo do link das linhas',
  },
  contatosLinkRotuloHelp: {
    id: 'mpf_imprensa_contatos_link_rotulo_help',
    defaultMessage:
      'Texto do link das unidades que têm página própria. Em branco, usa "{padrao}".',
  },

  fieldsetAtendimento: {
    id: 'mpf_imprensa_fieldset_atendimento',
    defaultMessage: 'Atendimento',
  },
  atendimentoTitulo: {
    id: 'mpf_imprensa_atendimento_titulo',
    defaultMessage: 'Título da coluna',
  },
  atendimentoTexto: {
    id: 'mpf_imprensa_atendimento_texto',
    defaultMessage: 'Texto',
  },
  atendimentoTextoHelp: {
    id: 'mpf_imprensa_atendimento_texto_help',
    defaultMessage: 'Explique em uma ou duas frases quem é atendido e quando.',
  },
  telefone: { id: 'mpf_imprensa_telefone', defaultMessage: 'Telefone' },
  email: { id: 'mpf_imprensa_email', defaultMessage: 'E-mail' },
  horario: {
    id: 'mpf_imprensa_horario',
    defaultMessage: 'Horário de atendimento',
  },

  fieldsetContatos: {
    id: 'mpf_imprensa_fieldset_contatos',
    defaultMessage: 'Contatos por estado',
  },
  contatosTitulo: {
    id: 'mpf_imprensa_contatos_titulo',
    defaultMessage: 'Título da coluna',
  },
  contatosLabel: {
    id: 'mpf_imprensa_contatos_label',
    defaultMessage: 'Rótulo do campo de busca',
  },
  contatosPlaceholder: {
    id: 'mpf_imprensa_contatos_placeholder',
    defaultMessage: 'Texto de exemplo do campo de busca',
  },
  contatos: { id: 'mpf_imprensa_contatos', defaultMessage: 'Contatos' },
  contatosHelp: {
    id: 'mpf_imprensa_contatos_help',
    defaultMessage:
      'A lista já vem preenchida com as unidades do MPF. Sem nenhum contato, a coluna não aparece na página.',
  },

  contato: { id: 'mpf_imprensa_contato', defaultMessage: 'Contato' },
  contatoUnidade: {
    id: 'mpf_imprensa_contato_unidade',
    defaultMessage: 'Unidade',
  },
  contatoUnidadeHelp: {
    id: 'mpf_imprensa_contato_unidade_help',
    defaultMessage: 'Sigla exibida na linha, ex.: "PR/AC". Campo obrigatório.',
  },
  contatoNome: {
    id: 'mpf_imprensa_contato_nome',
    defaultMessage: 'Nome por extenso',
  },
  contatoNomeHelp: {
    id: 'mpf_imprensa_contato_nome_help',
    defaultMessage:
      'Não aparece na linha: serve para a busca encontrar a unidade pelo nome do estado.',
  },
  contatoTelefone: {
    id: 'mpf_imprensa_contato_telefone',
    defaultMessage: 'Telefone',
  },
  contatoTelefoneHelp: {
    id: 'mpf_imprensa_contato_telefone_help',
    defaultMessage:
      'Com DDD, ex.: "(68) 3214-1430". Havendo ramal alternativo, separe com barra — o link de discagem usa o primeiro número.',
  },
  contatoEmail: { id: 'mpf_imprensa_contato_email', defaultMessage: 'E-mail' },
  contatoCidade: {
    id: 'mpf_imprensa_contato_cidade',
    defaultMessage: 'Cidade',
  },
  contatoCidadeHelp: {
    id: 'mpf_imprensa_contato_cidade_help',
    defaultMessage: 'Opcional. Aparece na linha, antes dos canais.',
  },
  contatoEndereco: {
    id: 'mpf_imprensa_contato_endereco',
    defaultMessage: 'Endereço',
  },
  contatoEnderecoHelp: {
    id: 'mpf_imprensa_contato_endereco_help',
    defaultMessage: 'Opcional. Aparece abaixo da linha da unidade.',
  },
  contatoLink: {
    id: 'mpf_imprensa_contato_link',
    defaultMessage: 'Página da unidade',
  },
  contatoLinkHelp: {
    id: 'mpf_imprensa_contato_link_help',
    defaultMessage:
      'Opcional. Endereço da página com endereço e horário: a linha ganha um link com o rótulo definido no bloco.',
  },
});

/** Rótulos que o bloco usa quando o editor não escreve outros. */
export const IMPRENSA_ROTULOS = {
  telefone: 'Telefone',
  telefoneSecundario: 'Telefone',
  email: 'E-mail',
  horario: 'Horário de atendimento',
  contatosLink: 'Ver endereço e horário',
} as const;

export type ImprensaVariante = 'padrao' | 'destaque';

/** Dado gravado pelo bloco. */
export interface ImprensaData {
  '@type'?: string;
  titulo?: string;
  /** Ausente equivale a `padrao`, o desenho de sempre. */
  variante?: ImprensaVariante;
  atendimentoTitulo?: string;
  atendimentoTexto?: string;
  telefone?: string;
  email?: string;
  horario?: string;
  telefoneSecundario?: string;
  telefoneRotulo?: string;
  telefoneSecundarioRotulo?: string;
  emailRotulo?: string;
  horarioRotulo?: string;
  contatosTitulo?: string;
  contatosLabel?: string;
  contatosPlaceholder?: string;
  contatosLinkRotulo?: string;
  contatos?: ImprensaContato[];
}

/**
 * Campos de uma linha da lista de contatos.
 *
 * `itemTitle` nomeia a linha do acordeão com a sigla da unidade em vez de
 * "Contato #17": numa lista de 34, o número não diz ao editor qual unidade ele
 * está prestes a abrir ou apagar. O gancho é da nossa customização do
 * `ObjectListWidget` (`customizations/volto/components/manage/Widgets/`) e cai
 * no rótulo numerado do core enquanto a sigla estiver em branco.
 */
const contatoItemSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.contato),
  addMessage: intl.formatMessage(messages.contato),
  itemTitle: (contato: ImprensaContato, index: number) =>
    contato?.unidade?.trim() ||
    contato?.nome?.trim() ||
    `${intl.formatMessage(messages.contato)} #${index + 1}`,
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'unidade',
        'nome',
        'telefone',
        'email',
        'cidade',
        'endereco',
        'link',
      ],
    },
  ],
  properties: {
    unidade: {
      title: intl.formatMessage(messages.contatoUnidade),
      description: intl.formatMessage(messages.contatoUnidadeHelp),
    },
    nome: {
      title: intl.formatMessage(messages.contatoNome),
      description: intl.formatMessage(messages.contatoNomeHelp),
    },
    telefone: {
      title: intl.formatMessage(messages.contatoTelefone),
      description: intl.formatMessage(messages.contatoTelefoneHelp),
    },
    email: {
      title: intl.formatMessage(messages.contatoEmail),
      widget: 'email',
    },
    cidade: {
      title: intl.formatMessage(messages.contatoCidade),
      description: intl.formatMessage(messages.contatoCidadeHelp),
    },
    endereco: {
      title: intl.formatMessage(messages.contatoEndereco),
      description: intl.formatMessage(messages.contatoEnderecoHelp),
      widget: 'textarea',
    },
    link: {
      title: intl.formatMessage(messages.contatoLink),
      description: intl.formatMessage(messages.contatoLinkHelp),
      widget: 'url',
    },
  },
  required: ['unidade'],
});

/**
 * Schema do bloco "Imprensa".
 *
 * `activeObject`/`setActiveObject` são o contrato do `ObjectListWidget` do
 * core: o par só entra em modo controlado com os dois presentes, e `-1` (não
 * `undefined`) é o que mantém a lista controlada com todos os itens fechados —
 * ver `Destaques/schema.ts` e `OndeAtua/schema.ts`.
 */
export const mpfImprensaSchema = ({
  intl,
  activeObject,
  setActiveObject,
}: {
  intl: IntlShape;
  activeObject?: number;
  setActiveObject?: (index: number) => void;
}) => ({
  title: intl.formatMessage(messages.titleBlock),
  fieldsets: [
    { id: 'default', title: 'Default', fields: ['titulo', 'variante'] },
    {
      id: 'atendimento',
      title: intl.formatMessage(messages.fieldsetAtendimento),
      fields: [
        'atendimentoTitulo',
        'atendimentoTexto',
        'telefone',
        'telefoneSecundario',
        'email',
        'horario',
        'telefoneRotulo',
        'telefoneSecundarioRotulo',
        'emailRotulo',
        'horarioRotulo',
      ],
    },
    {
      id: 'contatos',
      title: intl.formatMessage(messages.fieldsetContatos),
      fields: [
        'contatosTitulo',
        'contatosLabel',
        'contatosPlaceholder',
        'contatosLinkRotulo',
        'contatos',
      ],
    },
  ],
  properties: {
    titulo: {
      title: intl.formatMessage(messages.titulo),
      description: intl.formatMessage(messages.tituloHelp),
      placeholder: 'Imprensa',
    },
    variante: {
      title: intl.formatMessage(messages.variante),
      description: intl.formatMessage(messages.varianteHelp),
      choices: [
        ['padrao', intl.formatMessage(messages.variantePadrao)],
        ['destaque', intl.formatMessage(messages.varianteDestaque)],
      ],
      default: 'padrao',
    },

    atendimentoTitulo: {
      title: intl.formatMessage(messages.atendimentoTitulo),
      placeholder: 'Atendimento a jornalistas',
    },
    atendimentoTexto: {
      title: intl.formatMessage(messages.atendimentoTexto),
      description: intl.formatMessage(messages.atendimentoTextoHelp),
      widget: 'textarea',
    },
    telefone: { title: intl.formatMessage(messages.telefone) },
    telefoneSecundario: {
      title: intl.formatMessage(messages.telefoneSecundario),
      description: intl.formatMessage(messages.telefoneSecundarioHelp),
    },
    email: { title: intl.formatMessage(messages.email), widget: 'email' },
    horario: { title: intl.formatMessage(messages.horario) },
    telefoneRotulo: {
      title: intl.formatMessage(messages.telefoneRotulo),
      description: intl.formatMessage(messages.rotuloEmBranco, {
        padrao: IMPRENSA_ROTULOS.telefone,
      }),
      placeholder: IMPRENSA_ROTULOS.telefone,
    },
    telefoneSecundarioRotulo: {
      title: intl.formatMessage(messages.telefoneSecundarioRotulo),
      description: intl.formatMessage(messages.rotuloEmBranco, {
        padrao: IMPRENSA_ROTULOS.telefoneSecundario,
      }),
      placeholder: IMPRENSA_ROTULOS.telefoneSecundario,
    },
    emailRotulo: {
      title: intl.formatMessage(messages.emailRotulo),
      description: intl.formatMessage(messages.rotuloEmBranco, {
        padrao: IMPRENSA_ROTULOS.email,
      }),
      placeholder: IMPRENSA_ROTULOS.email,
    },
    horarioRotulo: {
      title: intl.formatMessage(messages.horarioRotulo),
      description: intl.formatMessage(messages.rotuloEmBranco, {
        padrao: IMPRENSA_ROTULOS.horario,
      }),
      placeholder: IMPRENSA_ROTULOS.horario,
    },

    contatosTitulo: {
      title: intl.formatMessage(messages.contatosTitulo),
      placeholder: 'Contatos por estado',
    },
    contatosLabel: {
      title: intl.formatMessage(messages.contatosLabel),
      placeholder: 'Estado',
    },
    contatosPlaceholder: {
      title: intl.formatMessage(messages.contatosPlaceholder),
      placeholder: 'Busque por estado ou sigla',
    },
    contatosLinkRotulo: {
      title: intl.formatMessage(messages.contatosLinkRotulo),
      description: intl.formatMessage(messages.contatosLinkRotuloHelp, {
        padrao: IMPRENSA_ROTULOS.contatosLink,
      }),
      placeholder: IMPRENSA_ROTULOS.contatosLink,
    },
    contatos: {
      title: intl.formatMessage(messages.contatos),
      description: intl.formatMessage(messages.contatosHelp),
      widget: 'object_list',
      schema: contatoItemSchema({ intl }),
      activeObject,
      setActiveObject,
    },
  },
  required: [],
});

export default mpfImprensaSchema;
